import { createSelector } from 'reselect';

export const getPublishedTour = (state) => state.publicTour;

export const getPublishedTourMedia = createSelector(
  [getPublishedTour],
  (publicTour) => {
    return {
      panos: publicTour.panos,
      images: publicTour.images,
      videos: publicTour.videos,
      videos360: publicTour.videos360,
      audio: publicTour.audio,
    }
  }
);
